// extracted by mini-css-extract-plugin
export default {"addIconContainer":"mobile-add-options_addIconContainer__qwp-D","actionButtons":"mobile-add-options_actionButtons__a4lJK","addIcon":"mobile-add-options_addIcon__FcZu1"};